// Utility to force refresh user data from backend
import ApiService from '../services/api-service';
import cookieStorage from '../services/cookie-storage';

export const forceRefreshUserData = async () => {
  try {
    const token = cookieStorage.getCookie('Authorization');
    if (!token) {
      console.log('No auth token, cannot refresh user data');
      return null;
    }
    
    console.log('Force refreshing user data from backend...');
    const response = await ApiService.USER_PROFILE();
    
    if (response && response.result) {
      // Store with consistent structure
      const userData = {
        userData: response.result
      };
      
      localStorage.setItem('userData', JSON.stringify(userData));
      localStorage.setItem('isWhiteListed', response.result.isWhiteListed);
      
      console.log('User data refreshed:', {
        id: response.result._id,
        birthYear: response.result.birthYear,
        isWhiteListed: response.result.isWhiteListed
      });
      
      return response.result;
    }
    
    return null;
  } catch (error) {
    console.error('Failed to refresh user data:', error);
    return null;
  }
};

// Auto-refresh if logged in but missing birthYear in cache
export const checkAndRefreshIfNeeded = async () => {
  const token = cookieStorage.getCookie('Authorization');
  if (!token) return;

  const cachedData = localStorage.getItem('userData');
  if (!cachedData) {
    console.log('No cached userData, refreshing...');
    return await forceRefreshUserData();
  }

  try {
    const parsed = JSON.parse(cachedData);
    const userData = parsed.userData || parsed;

    if (!userData.birthYear) {
      console.log('Cached userData missing birthYear, refreshing...');
      return await forceRefreshUserData();
    }

    return userData;
  } catch (e) {
    console.error('Error parsing cached userData:', e);
    return await forceRefreshUserData();
  }
};

// Check if premium status needs refresh (for mobile subscriptions)
export const checkPremiumStatusAndRefresh = async () => {
  try {
    const token = cookieStorage.getCookie('Authorization');
    if (!token) return null;

    // Check last refresh time to avoid excessive API calls
    const lastRefresh = localStorage.getItem('lastPremiumCheck');
    const now = Date.now();

    // Only check every 5 minutes
    if (lastRefresh && (now - parseInt(lastRefresh)) < 5 * 60 * 1000) {
      return null;
    }

    const cachedData = localStorage.getItem('userData');
    if (!cachedData) {
      return await forceRefreshUserData();
    }

    const parsed = JSON.parse(cachedData);
    const cachedUserData = parsed.userData || parsed;

    // Fetch fresh data from backend
    const response = await ApiService.USER_PROFILE();

    if (response && response.result) {
      const freshUserData = response.result;

      // Check if premium status changed
      if (cachedUserData.hasPremium !== freshUserData.hasPremium) {
        console.log('Premium status changed! Updating cache...', {
          cached: cachedUserData.hasPremium,
          fresh: freshUserData.hasPremium
        });

        // Update localStorage with fresh data
        localStorage.setItem('userData', JSON.stringify({ userData: freshUserData }));
        localStorage.setItem('isWhiteListed', freshUserData.isWhiteListed);
        localStorage.setItem('lastPremiumCheck', now.toString());

        // Reload page to apply changes
        window.location.reload();
        return freshUserData;
      }

      // Update last check time even if no changes
      localStorage.setItem('lastPremiumCheck', now.toString());

      return freshUserData;
    }

    return null;
  } catch (error) {
    console.error('Failed to check premium status:', error);
    return null;
  }
};